import type { BrandSummary } from "@shared/types";
import { BrandCard } from "./BrandCard";

export function BrandGrid({ brands, emptyMessage = "No brands match these filters yet." }: { brands: BrandSummary[]; emptyMessage?: string }) {
  if (!brands.length) return <div className="empty-state">{emptyMessage}</div>;
  return (
    <div className="brand-grid">
      {brands.map((b) => <BrandCard key={b.id} brand={b} />)}
    </div>
  );
}
